import { Fragment } from 'react';
import type { AttendanceVerification } from '../api/types';
import { verificationLabel } from './attendanceVerification';
import { GongLinks } from './GongLinks';

// One compact line above the Met and Attended drawers: how many Gong-confirmed no-shows were
// taken out, and which. Unverified sittings are not listed; they count like any other meeting.
export function AttendanceEvidence({ evidence }: { evidence: AttendanceVerification }) {
  if (!evidence.removed.length) return null;
  return <p className="attendance-evidence" aria-label="Gong-confirmed no-shows removed">
    <strong>{verificationLabel(evidence)}:</strong>{' '}
    {evidence.removed.map((member, index) => <Fragment key={`${member.account_id}-${member.day}-${index}`}>
      {index ? '; ' : ''}
      <span className="attendance-removed">
        {member.account} · {member.day ?? '—'} <GongLinks urls={member.gong_call_urls} />
      </span>
    </Fragment>)}
  </p>;
}
